<template>
	<div>
        <b-modal v-model="modal_status" :title="add_taxonomy_title" ok-title="Submit"
		 @cancel="closeModal" @ok="actionDefine" :ok-disabled="new_taxonomy_name == ''"
		>
			<form @submit.prevent="actionDefine">
				<div class="lightgray-content p-3 rounded mb-2">
					<div class="row">
						<div class="col-12">
							<div class="form-group input-content">
								<label>{{current_taxonomy_field}} name</label>
								<input :disabled="delete_option" type="text" v-model="new_taxonomy_name" class="form-control" v-validate="'required'" name="taxonomy_">
								<span class="input-error-msg" v-if="errors.first('taxonomy_')">{{current_taxonomy_field}} is required</span>
							</div>							
						</div><!--col-->
					</div><!--row-->
				</div>
			</form>
		</b-modal>
	</div>
</template>
<script>
export default {
	props:{
		new_taxonomy_modal:{
			type: Boolean
		},
		add_taxonomy_title:{
			type: String,
			required: true
		},
		current_taxonomy_field:{
			type: String,
			required: true
		},
		parent_subject: {
			type: Object
		},
		delete_option:{
			type: Boolean
		},
		add_option:{
			type: Boolean
		},
		item:{
			type: Object
		}

	},
	computed:{
		current_agency(){
			return this.$route.params.agency_id
		}
	},
	data : function(){
		return{
			new_taxonomy_name: ''
		}
	},
	created : function(){
		this.modal_status = this.new_taxonomy_modal
		if(!this.add_option){
			this.new_taxonomy_name = this.item.name
		}
		
	},
	methods : {
		actionDefine: function(){
			if(this.add_option){
				this.createTaxonomy()
			}else if(this.delete_option){
				this.deleteTaxonomy()
			}else{
				this.editTaxonomy()
			}
		},
		editTaxonomy: function(){
			var params = {
				id : this.current_agency,
				value_id : this.item.id,
				name : this.new_taxonomy_name,
				parent_id: this.parent_subject.id,
				filters : {
					type : this.current_taxonomy_field[0].toLowerCase()+ this.current_taxonomy_field.slice(1),
				}
			}

			this.$store.dispatch('editTaxonomyValue', params).then((res) => {
				this.closeModal();
			}).catch((error) => {
				console.log(error);
			});
			
		},
		deleteTaxonomy: function(){
			var params = {
				id : this.current_agency,
				value_id : this.item.id,
				filters : {
					type : this.current_taxonomy_field[0].toLowerCase()+ this.current_taxonomy_field.slice(1),
					parent_id: this.parent_subject.id
				}
			}
			this.$store.dispatch('deleteTaxonomyValue', params).then((res) => {
				console.log(res)
				this.closeModal()
			}).catch((error) => {
				console.log(error);
			});
			
		},
        createTaxonomy : function(){
			this.$validator.validateAll(['taxonomy_']).then((result) => {
				if(result){
					var params = {
						id : this.current_agency,
						name : this.new_taxonomy_name,
						filters : {
							type : this.current_taxonomy_field[0].toLowerCase()+ this.current_taxonomy_field.slice(1),
                            parent_id: this.parent_subject.id
						}
					}
					this.$store.dispatch('createTaxonomyValue', params).then((res) => {
						this.closeModal()
						this.$emit('getLocations',({}))
					}).catch((error) => {
						console.log(error);
						this.closeModal()

					});
				}
			});
		},
		closeModal: function(){
			this.modal_status = false
			this.new_taxonomy_name = ''
			this.$emit('closeModal')
		}
	}
	
}
</script>


// WEBPACK FOOTER //
// src/components/admin/organization/shared/OrganizationSubLocationAddDeleteEdit.vue